<div class="overlay animated fadeIn" *ngIf="showURLError || showReceptionVisualizer || showInvoiceVisualizer || parent.loading"></div>

<div class="InfoQuestion animated fadeInDown" *ngIf="showURLError">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="showURLError = false; backClicked();">close</i>
    </div>
    <div class="InfoQuestionTitle">
     {{'DocumentsViewPageURLError' | translate}}
    </div>
    <div class="InfoQuestionBody">
      {{'DocumentsViewPageURLErrorDesc' | translate}}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" color="warn" mat-raised-button class="InfoQuestionButton" (click)="showURLError = false; backClicked();">
        {{ 'OK' | translate }}
      </button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeactivateDocumentQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeactivateDocumentQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'DocumentDeactivationTitle' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'DocumentDeactivationDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false;">{{ 'No' | translate }}</button>
    <button *ngIf="this.CurrentInvoice != null;" [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false;CancelOrActivate(CurrentInvoice.ID, true);">{{ 'Yes' | translate }}</button>
    <button *ngIf="this.CurrentReception != null;" [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false;CancelReception(CurrentReception);">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowReactivateDocumentQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowReactivateDocumentQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'DocumentReactivationTitle' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'DocumentReactivationDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowReactivateDocumentQuestion = false;">{{ 'No' | translate }}</button>
    <button *ngIf="this.CurrentInvoice != null;" [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowReactivateDocumentQuestion = false;CancelOrActivate(CurrentInvoice.ID, False);">{{ 'Yes' | translate }}</button>
    <button *ngIf="this.CurrentReception != null;" [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false;ActivateReception(CurrentReception);">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="animated fadeInDown DocumentContainer" *ngIf="showInvoiceVisualizer" style="width: 50%;left: 25%;">

  <div class="PopUpRightBackButton">
    <button mat-raised-button style="outline: none;" (click)="this.parent.RedirectToURL('dashboard/documents/invoices');" *ngIf="this.IsDifferentCompanyThanOriginal != true;">
      <i class="material-icons PopUpRightBackButtonicon">arrow_back_ios_new</i>
      {{'Back' | translate}}
    </button>
  </div>

   <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;margin-top: 7.5%;">
    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button color="primary" class="VizualizeCommandButton" style="outline: none;" (click)="ExportInvoice(this.CurrentInvoice);">
      <i class="material-icons">file_copy</i>
      <span>{{ 'Receptions.Document.Export' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" style="outline: none;" (click)="PrintInvoice(this.CurrentInvoice);">
      <i class="material-icons">print</i>
      <span>{{ 'Receptions.Document.Print' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" *ngIf="this.IsDifferentCompanyThanOriginal != true;" mat-raised-button class="VizualizeCommandButton" style="outline: none;" (click)="this.parent.InitializeEmailSendContainer(this.CurrentInvoice.Client, this.CurrentInvoice.GeneralDocType, this.CurrentInvoice.ID);">
      <i class="material-icons">attach_email</i>
      <span>{{ 'Email' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" style="outline: none;" *ngIf="this.CurrentInvoice.Details?.ShippingDetails?.TrackingLabel?.length > 0;" (click)="TrackInvoice(CurrentInvoice);">
      <i class="material-icons">near_me</i>
      <span>{{ 'Track' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" [matMenuTriggerFor]="menuPopUpInvoice" *ngIf="this.IsDifferentCompanyThanOriginal != true;">
      <i class="material-icons">settings</i>
        <span>{{'Actions' | translate}}</span>
      </button>
    <mat-menu #menuPopUpInvoice="matMenu">
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" (click)="ViewInvoice(CurrentInvoice);">
          <i class="material-icons">mode_edit</i>
          <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" (click)="GenerateInvoicesDeliveryNote(CurrentInvoice);">
        <i class="material-icons">sticky_note_2</i>
        <span>{{ 'DeliveryNote' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1 && CurrentInvoice.IsStorno != true && CurrentInvoice.DocType.ID != 1;" (click)="GenerateNewInvoice(CurrentInvoice, true, false);">
          <i class="material-icons">settings_backup_restore</i>
          <span>{{ 'Receptions.Table.ButtonMenu.stornate' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" (click)="this.ShowDeactivateDocumentQuestion = true;">
          <i class="material-icons">close</i>
          <span>{{ 'Receptions.Table.ButtonMenu.cancelDoc' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID == -1;" (click)="this.ShowReactivateDocumentQuestion = true;">
          <i class="material-icons">verified</i>
          <span>{{ 'Receptions.Table.ButtonMenu.reactivateDoc' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" (click)="GenerateNewInvoice(CurrentInvoice, false, true);">
          <i class="material-icons">content_copy</i>
          <span>{{ 'Copy' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" (click)="GetInvoiceMasterData();">
        <i class="material-icons">monetization_on</i>
        <span>{{ 'Collect' | translate }}</span>
      </button>
    </mat-menu>

    <button *ngIf="this.IsDifferentCompanyThanOriginal != true;" [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintInvoice(this.CurrentInvoice);" mat-raised-button class="VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
      <i class="material-icons">print</i>
      <span>{{ 'AutoPrint' | translate }}</span>
    </button>

    <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
  </div>

   <div class="PopUpBody" style="max-height: 75vh;">
      <p class="DocumentBodyCanceled" *ngIf="CurrentInvoice.DocumentStatus.ID == -1;">anulata</p>

      <div *ngIf="!CurrentInvoice.IsStorno" class="DocumentStatusContainer" [ngClass]="{'CancelledStatusPopUp': CurrentInvoice.DocumentStatus.ID == -1, 'CollectedStatusPopUp': CurrentInvoice.DocumentStatus.ID == 1,'PartiallyCollectedPopUp': CurrentInvoice.DocumentStatus.ID == 2,'SurplusCollectedPopUp': CurrentInvoice.DocumentStatus.ID == 3, 'CreatedStatusPopUp': CurrentInvoice.DocumentStatus.ID == 4, 'OverduePopUp': CurrentInvoice.DocumentStatus.ID == 5}">
        <span style="float: left;">{{CurrentInvoice.DocumentStatus.Name}}:</span>
        <span *ngIf="CurrentInvoice.DocumentStatus.ID == 5;"> ({{CurrentInvoice.OverduePaymentDays}} {{'DaysLate' | translate}}, {{CurrentInvoice.Details.EmailNotificationsCount}} {{'SendEmailNotifications' | translate}})</span>
        <div *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" style="float: left;">
          <span *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue > 0;"> {{'RemainingToCashCollect' | translate}}: {{this.CurrentInvoice.Details.CashCollectionRemainingValue}} {{this.CurrentInvoice.Currency.Name}}</span>
          <span *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue < 0;"> {{'OverCashCollected' | translate}}: {{this.CurrentInvoice.Details.CashCollectionRemainingValue}} {{this.CurrentInvoice.Currency.Name}}</span>
        </div>
      </div>

      <table style="border: solid 1px #aaa;
      padding: 20px;
      font-weight: 400;
      margin-top: 2.5%;
      position: relative;
      margin-bottom: 2.5px;
      border-collapse: separate !important;
      border-radius: 4px;margin-top: 5px;">
        <tbody>
          <tr>
            <td style="border-radius: 3px;">
              <table style="width: 100%;">
                <tbody>
                  <tr style="width: 50%;max-height: 100px;float: left;">
                    <img alt="{{this.CurrentInvoice.Company.Name}}" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath != null;" [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath" style="max-width: 50%;max-height: 100%;"/>
                    <td style="width: 75%;
                    float: left;
                    font-size: 26px;
                    font-weight: 700;
                    line-height: 30px;
                    text-transform: uppercase;" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath == null;">{{this.CurrentInvoice.Company.Name}}</td>
                  </tr>
                  <tr style="width: 50%;float: left;">
                     <table style="width: 100%;float: left;">
                       <tbody>
                        <tr style="width: 50%;float: left;font-size: 18px;font-weight: 700;text-transform: uppercase;">
                          {{CurrentInvoice.DocType.Meaning}}
                        </tr>
                        <tr style="width: 50%;float: left;text-align: right;font-weight: 700;font-size: 22px;padding-right: 5px;">
                          {{CurrentInvoice.AccountingNumber.DisplayValue}}
                        </tr>
                       </tbody>
                     </table>
        
                      <table style="width: 100%;float: left;margin-top: 10px;">
                        <tbody>
                          <tr style="width: 50%;float: left;font-size: 13px;">
                            {{ 'CreatingDate' | translate }}: {{CurrentInvoice.EventRegisterUIDate}}
                          </tr>
                          <tr style="width: 50%;float: left;text-align: right;font-size: 13px;padding-right: 5px;" *ngIf="CurrentInvoice.VATs.length == 1;">
                            {{ 'VATRate' | translate }}: <span *ngFor="let v of CurrentInvoice.VATs">{{v.Name}}</span>
                          </tr>
                        </tbody>
                      </table>
        
                     <table style="width: 100%;float: left;margin-top: 10px;">
                       <tbody>
                        <tr style="width: 100%;float: left;height: auto;background: #254a91;border-radius: 3px;line-height: 40px;text-align: right;color: #fff;font-size: 20px;font-weight: 500;">
                          <td style="float: left;width: 100%;padding: 0;">
                           <table style="width: 100%;">
                             <tbody>
                              <tr style="width: 50%;float: left;font-size: 18px;text-align: left;padding-left: 10px;text-transform: uppercase;">
                                {{ 'TotalValue' | translate }}
                              </tr>
                              <tr style="width: 50%;float: left;font-size: 18px;text-align: right;padding-right: 10px;text-transform: uppercase;">
                                <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                                <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                                <span style="font-size: 14px;"> {{CurrentInvoice.Currency.Name}}</span>
                              </tr>
                             </tbody>
                           </table>

                           <table style="width: 100%;" *ngIf="CurrentInvoice.MainCurrency?.TotalDisplayValue != null;">
                            <tbody>
                             <tr style="width: 50%;min-height: 20px;float: left;font-size: 18px;text-align: left;padding-left: 10px;text-transform: uppercase;">
                               
                             </tr>
                             <tr style="width: 50%;float: left;font-size: 12px;text-align: right;padding-right: 10px;text-transform: uppercase;line-height: 5px;">
                               <span>{{CurrentInvoice.MainCurrency.UITotalDisplayValue.Integer}}</span>
                               <span>{{CurrentInvoice.MainCurrency.UITotalDisplayValue.Decimals}}</span> 
                               <span style="font-size: 12px;"> {{CurrentInvoice.MainCurrency.Name}}</span>
                             </tr>
                            </tbody>
                          </table>
                          </td>
                        </tr>
                       </tbody>
                     </table>
        
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                    <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                      <tr style="width: 60%;
                      float: left;
                      padding-left: 5px;
                      text-transform: uppercase;
                      font-weight: 500;
                      height: 30px;
                      line-height: 30px;
                      border-bottom: solid 2px #254a91;
                      margin-top: 10px;">{{ 'Supplier' | translate }}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-weight: 700;
                      font-size: 16px;">{{this.CurrentInvoice.Company.Name}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Company.VATNumber}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'RegCom' | translate }}: {{this.CurrentInvoice.Company.COCRegisterNr}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Company.Addresses[0].Country.Name}} 
                       {{this.CurrentInvoice.Company.Addresses[0].StateProvince}}
                       {{this.CurrentInvoice.Company.Addresses[0].City}}
                       {{this.CurrentInvoice.Company.Addresses[0].AddressLine}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{this.CurrentInvoice.Company.Banks[0]?.BankAccounts[0]?.Currency.Name}}) : {{this.CurrentInvoice.Company.Banks[0]?.BankAccounts[0]?.AccountNumber}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'Partners.PartnerWindow.Bank' | translate }}: {{this.CurrentInvoice.Company.Banks[0]?.Name}}</tr>
        
                    </td>
                  </tr>
                  <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                    <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                      <tr style="width: 60%;
                      float: left;
                      padding-left: 5px;
                      text-transform: uppercase;
                      font-weight: 500;
                      height: 30px;
                      line-height: 30px;
                      border-bottom: solid 2px #254a91;
                      margin-top: 10px;">{{ 'Client' | translate }}</tr> 
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-weight: 700;
                      font-size: 16px;">{{this.CurrentInvoice.Client.Name}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Client.VAT}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 0px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Client.BillingAddress.StateProvince}} {{this.CurrentInvoice.Client.BillingAddress.City}} {{this.CurrentInvoice.Client.BillingAddress.AddressLine}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 0px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'Country' | translate }}: {{this.CurrentInvoice.Client.BillingAddress.Country.Name}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 0px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'Login.Email' | translate }}: {{this.CurrentInvoice.Client.ContactInfo.Email}}</tr>
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;margin-top: 20px;height: 2px;background: #254a91;">
                    
                  </tr>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      {{ 'Receptions.Table.Nr' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                      {{ 'Receptions.Table.Name' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      {{ 'Receptions.Table.MU' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      {{ 'Receptions.Table.Qty' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;">
                      {{ 'Receptions.Table.Price' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;">
                      {{ 'Receptions.Table.Total' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      {{ 'Receptions.Table.VAT' | translate }}
                    </td>
                  </tr>
                  <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #254a91;">
                    
                  </tr>
        
                  <tr style="float: left;width: 100%;height: auto;min-height: 12px;padding-bottom: 10px;" *ngFor="let p of CurrentInvoice.Products; let i=index;" [ngClass]="{'GrayRow': i % 2 != 0}">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 7.5%;text-align: center;">
                      {{i + 1}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;height: auto;float: left;min-height: 12px;width: 30%;text-align: left;">
                      <p style="margin:0;margin-bottom:5px;">{{p.ProductInvoiceInfo.Name}}</p>
                      <p *ngFor="let row of p.ProductInvoiceInfo.DescriptionRows; let j=index;" style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;">
                          {{row}}
                      </p>
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                      {{p.ProductInvoiceInfo.MeasuringUnit.Name}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                      {{p.ProductInvoiceInfo.Quantity}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 17.5%;text-align: right;">
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIUnitPrice}}</span>
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIUnitPriceDiscount}}</span>
        
                      <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">
                        Discount - {{p.ProductInvoiceInfo.Price.Discount.Value}} 
                        <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">%</span>
                        <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 2;">{{this.CurrentInvoice.Currency.Name}}</span>
                      </p>
                      <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null && p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">
                        Initial - {{p.ProductInvoiceInfo.Price.UIUnitPrice}} {{this.CurrentInvoice.Currency.Name}}
                      </p>
        
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 15%;text-align: right;">
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIQtyPrice}}</span>
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIQtyPriceDiscount}}</span>
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                      <span>{{p.ProductInvoiceInfo.Price.TotalVATValue}}</span>
                    </td>
                  </tr>
        
                  <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #aaa;">
                    
                  </tr>
        
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      {{ 'InvoiceCreator' | translate }}:
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;text-transform: capitalize;">
                      {{this.CurrentInvoice.Details.Agent.Name}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                      Total:
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;background: #f6f6f6;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;background: #f6f6f6;">
                         <span>{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Integer}}</span>
                         <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Decimals}}</span> 
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                      <span>{{CurrentInvoice.Total.UITotalVAT.Integer}}</span>
                      <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalVAT.Decimals}}</span> 
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                      {{ 'TotalPayment' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                      <span> {{CurrentInvoice.Currency.Name}}</span>
                    </td>
                  
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                      {{ 'PaymentTerms' | translate }}:
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                       {{this.CurrentInvoice.PaymentDueDateUI}}
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;" *ngIf="CurrentInvoice.Details.Agent != null && CurrentInvoice.Details.Agent.ID != null && CurrentInvoice.Details.IsSignedByAgent && this.Products.length > 0;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                  
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                     
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                      <img [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.Agent?.Signature" style="height: auto;
                      width: auto;
                      max-width: 100%;
                      max-height: 100px;"/>
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                    
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 30px;width: 50%;text-align: left;padding-left: 5px;">
                      {{this.CurrentInvoice.Details.Observations}}
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;background: #f6f6f6;">
                <tbody>
                  <tr>
                    <td style="padding:5px;">
                      <tr style="float: left;width: 100%;height: auto;">
                        <td style="line-height: 12px;font-size: 12px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{this.CurrentInvoice.Company.Name}}
                        </td>
                      </tr>
                      <tr style="float: left;width: 100%;height: auto;">
                        <td style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{ 'Telephone' | translate }}: {{this.CurrentInvoice.Details.Agent.Phone}}; Email: {{this.CurrentInvoice.Details.Agent.Email}}
                        </td>
                      </tr>
                      <tr style="float: left;width: 100%;height: auto;" *ngFor="let b of this.CurrentInvoice.Company.Banks">
                        <td *ngFor="let a of b.BankAccounts" style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{a.Currency.Name}}) : {{a.AccountNumber}}
                        </td>
                      </tr>
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;" *ngIf="this.CurrentInvoice.Details.SignStampSubstituteRows.length > 0;">
                <tbody>
                  <tr>
                    <td style="padding:5px;">
                      <tr style="float: left;width: 100%;height: auto;" *ngFor="let row of this.CurrentInvoice.Details.SignStampSubstituteRows">
                        <td style="line-height: 11px;font-size: 11px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{row}}
                        </td>
                      </tr>
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                  
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                     
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 50%;text-align: right;padding-right: 10px;">
                      {{'DocumentGeneratedBySoftware' | translate}}: <a href="https://www.foxcloud.ro" style="color: #254a91;">www.foxcloud.ro</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
   </div>
 
</div>

<div class="animated fadeInDown DocumentContainer" *ngIf="showReceptionVisualizer">
  <div class="PopUpCloseContainer" (click)="this.parent.RedirectToURL('dashboard/documents/receptions');">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID == null && !DocumentBodyLoading;">
      <span *ngIf="!IsStorno;">{{ 'Receptions.NewReception' | translate }}</span>
      <span *ngIf="IsStorno;">{{ 'Receptions.StornoReception' | translate }}</span>
      </p>
      <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID != null && !DocumentBodyLoading;">
        <span>
          {{CurrentReception.AccountingNumber.AccountingSeries.Series}} 
          {{(CurrentReception.AccountingNumber.Number)}} 
          / {{CurrentReception.EventRegisterUI}}
        </span>
      </p>
   </div> 

   <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button color="primary" class="VizualizeCommandButton" (click)="ExportReception(CurrentReception);">
      <i class="material-icons">file_copy</i>
      <span>{{ 'Receptions.Document.Export' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" (click)="PrintReception(CurrentReception);">
      <i class="material-icons">print</i>
      <span>{{ 'Receptions.Document.Print' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" [matMenuTriggerFor]="menuReception" *ngIf="this.IsDifferentCompanyThanOriginal != true;">
      <i class="material-icons">settings</i>
      <span>{{ 'Receptions.Document.Actions' | translate }}</span>
    </button>   
    
    <mat-menu #menuReception="matMenu">
      <button mat-menu-item (click)="ViewReception(CurrentReception);" class="ReceptionMenuButton" *ngIf="CurrentReception.DocumentStatus.ID != -1;">
          <i class="material-icons">mode_edit</i>
          <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
      </button>
      
      <button mat-menu-item class="ReceptionMenuButton" (click)="DownloadFile(CurrentReception);" *ngIf="CurrentReception.FilePath != null;">
        <i class="material-icons">file_download</i>
        <span>{{ 'DownloadFile' | translate }}</span>
      </button>

      <button mat-menu-item class="ReceptionMenuButton" (click)="GenerateStorno(CurrentReception);" *ngIf="CurrentReception.DocumentStatus.ID != -1 && CurrentReception.IsStorno != true;">
          <i class="material-icons">settings_backup_restore</i>
          <span>{{ 'Receptions.Table.ButtonMenu.stornate' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentReception.DocumentStatus.ID != -1;" (click)="this.ShowDeactivateDocumentQuestion = true;">
          <i class="material-icons">close</i>
          <span>{{ 'Receptions.Table.ButtonMenu.cancelDoc' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentReception.DocumentStatus.ID == -1;" (click)="this.ShowReactivateDocumentQuestion = true;">
          <i class="material-icons">verified</i>
          <span>{{ 'Receptions.Table.ButtonMenu.reactivateDoc' | translate }}</span>
      </button>
     </mat-menu>

     <button *ngIf="this.IsDifferentCompanyThanOriginal != true;" [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintReception(CurrentReception);" mat-raised-button class="VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
      <i class="material-icons">print</i>
      <span>{{ 'AutoPrint' | translate }}</span>
    </button>

    <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
  </div>

   <div class="PopUpBody" style="max-height: 75vh;" *ngIf="!CurrentReception.IsStorno">
     <div class="DocumentBody">

      <p class="DocumentBodyCanceled" *ngIf="CurrentReception.DocumentStatus.ID == -1;">anulata</p>

       <div style="border: solid 1px #333;">
        
        <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
          <tbody>
            <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
              <td>{{ 'Receptions.Document.Title' | translate }}</td>
            </tr>

            <table style="width: 100%;margin-top: 25px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                  <td>{{ 'Receptions.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.DocNr' | translate }}:  {{CurrentReception.AccountingNumber.AccountingSeries.Series}}{{(CurrentReception.AccountingNumber.Number)}}</td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                  <td>{{ 'Receptions.Document.Administrations' | translate }}: 
                    <span *ngFor="let a of this.CurrentReception.Administrations; let i=index;">{{a.Name}}; </span>
                  </td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.Date' | translate }}: {{CurrentReception.EventRegisterUI}}</td>
                </tr>
              </tbody>
            </table>
           
          </tbody>
        </table>

        <table style="width: 100%;border-bottom: solid 1px #333;">
          <tbody>
            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.UndersignedTitle' | translate }} {{this.CurrentReception.Supplier.Name}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.SupplyingDocuments' | translate }}: {{this.CurrentReception.DocumentNumber}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Delegate' | translate }}: {{this.CurrentReception.Details.Delegate}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Observations' | translate }}: {{this.CurrentReception.Details.Observations}}
                  </td>
                </tr>
              </tbody>
            </table>
            
            <table style="width: 100%;margin-top: 5px;margin-bottom: 20px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Auto' | translate }}: {{this.CurrentReception.Details.Auto}}
                  </td>
                </tr>
              </tbody>
            </table>

          </tbody>
        </table>

        <table style="width: 100%;">
          <tbody>
            
            <table style="width: 100%;font-size: 12px;">
              <tbody>
                <tr style="width: 100%;">

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.Nr' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'Receptions.Document.Table.Name' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.MU' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'Receptions.Document.Table.DocQuantity' | translate }}</td>
                      </tr>
                    </tbody>
                    </table>
                  </td>

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>

                      <tr>
                      <td style="padding: 0;">
                        <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                          <tbody>
                            <tr>
                              <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'Receptions.Document.Table.Received' | translate }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>

                      <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;padding: 0;">
                            <tbody>
                              <tr>
                                <td style="text-align: center;width: 15%;padding: 0;">{{ 'Receptions.Document.Table.Quantity' | translate }}</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.UnitPrice' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.TotalValue' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 25%;padding: 0;">{{ 'Receptions.Document.Table.VATValue' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>

                    </tbody>
                    </table>
                  </td>

                </tr>

                <tr style="width: 100%;">

                 <td style="padding: 0;">
                  <table style="width: 100%;">
                    <tbody>
                      <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentReception.Products; let i=index;">
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{i + 1}}
                        </td>
            
                        <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          ({{p.ProductReceptionInfo.Code}}) {{p.ProductReceptionInfo.Name}}
                        </td>
            
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.MeasuringUnit.Name}}
                        </td>
            
                        <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.DocQuantity}}
                        </td>
            
                        <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Quantity}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIUnitPrice}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIQtyPrice}}
                        </td>
            
                        <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{p.ProductReceptionInfo.Price.TotalVATValue}}
                        </td>
                      </tr>
                    </tbody>
                    </table>
                 </td>

                </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'VATPercentages' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.TotalNOVAT' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.VATValue' | translate }}:
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{ 'Receptions.Document.Table.Total' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                           <span *ngFor="let vat of CurrentReception.VATs">{{vat?.Percentage}}%; </span>
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceNOVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceVAT}} {{CurrentReception.Currency.Name}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.ReceptionCommitee' | translate }}: {{CurrentReception.Details.ReceptionCommittee}}
                         </td>
             
                         <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.ReceivedInAdministration' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
             
                         <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                           
                         </td>
             
                         <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{CurrentReception.UpdatingUser.UserName}}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Currency' | translate }}: {{CurrentReception.Details.CurrencyRow}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

              </tbody>
            </table>

          </tbody>
        </table>

       </div>

     </div>
   </div>

   <div class="PopUpBody" style="max-height: 75vh;" *ngIf="CurrentReception.IsStorno">
    <div class="DocumentBody">

     <p class="DocumentBodyCanceled" *ngIf="CurrentReception.DocumentStatus.ID == -1;">anulata</p>

      <div style="border: solid 1px #333;">
        <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
          <tbody>
            <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
              <td>{{ 'Receptions.Document.DocumentStorno.ReturnTitle' | translate }}</td>
            </tr>

            <table style="width: 100%;margin-top: 25px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                  <td>{{ 'Receptions.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.DocNr' | translate }}:  {{CurrentReception.AccountingNumber.AccountingSeries.Series}}{{(CurrentReception.AccountingNumber.Number)}}</td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                  <td>{{ 'Receptions.Document.Administrations' | translate }}: 
                    <span *ngFor="let a of this.CurrentReception.Administrations; let i=index;">{{a.Name}}; </span>
                  </td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.Date' | translate }}: {{CurrentReception.EventRegisterUI}}</td>
                </tr>
              </tbody>
            </table>
           
          </tbody>
        </table>

        <table style="width: 100%;border-bottom: solid 1px #333;">

          <tbody>
            <table style="width: 100%;margin-top: 5px;margin-bottom: 25px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.DocumentStorno.ReturnSubTitle' | translate }} {{this.CurrentReception.Supplier.Name}} 
                    {{ 'Receptions.Document.DocumentStorno.OnDocumentBasis' | translate }} {{CurrentReception.DocumentNumber}} / {{CurrentReception.DocumentDate}}
                  </td>
                </tr>
              </tbody>
            </table>
          </tbody>

        </table>

        <table style="width: 100%;">
          <tbody>
            
            <table style="width: 100%;font-size: 12px;">
              <tbody>
                <tr style="width: 100%;">

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.Nr' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'Receptions.Document.Table.Name' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.MU' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'Receptions.Document.Table.DocQuantity' | translate }}</td>
                      </tr>
                    </tbody>
                    </table>
                  </td>

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>

                      <tr>
                      <td style="padding: 0;">
                        <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                          <tbody>
                            <tr>
                              <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'Receptions.Document.Table.Returned' | translate }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>

                      <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;padding: 0;">
                            <tbody>
                              <tr>
                                <td style="text-align: center;width: 15%;padding: 0;">{{ 'Receptions.Document.Table.Quantity' | translate }}</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.UnitPrice' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.TotalValue' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 25%;padding: 0;">{{ 'Receptions.Document.Table.VATValue' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>

                    </tbody>
                    </table>
                  </td>

                </tr>

                <tr style="width: 100%;">

                 <td style="padding: 0;">
                  <table style="width: 100%;">
                    <tbody>
                      <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentReception.Products; let i=index;">
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{i + 1}}
                        </td>
            
                        <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          ({{p.ProductReceptionInfo.Code}}) {{p.ProductReceptionInfo.Name}}
                        </td>
            
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.MeasuringUnit.Name}}
                        </td>
            
                        <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.DocQuantity}}
                        </td>
            
                        <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Quantity}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIUnitPrice}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIQtyPrice}}
                        </td>
            
                        <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{p.ProductReceptionInfo.TotalVATValue}}
                        </td>
                      </tr>
                    </tbody>
                    </table>
                 </td>

                </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.TotalNOVAT' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.VATValue' | translate }}:
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{ 'Receptions.Document.Table.Total' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceNOVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceVAT}} {{CurrentReception.Currency.Name}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.ReceptionCommitee' | translate }}: {{CurrentReception.Details.ReceptionCommittee}}
                         </td>
             
                         <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.ReceivedInAdministration' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
             
                         <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                           
                         </td>
             
                         <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{CurrentReception.UpdatingUser.UserName}}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Currency' | translate }}: {{CurrentReception.Details.CurrencyRow}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

              </tbody>
            </table>

          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>

<div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowCashCollectionContainer">
  <div class="PopUpCloseContainer" (click)="ShowCashCollectionContainer = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p>{{ 'NewCashCollection' | translate }}</p>
   </div>

   <div class="PopUpBody" style="margin-top: 20px;">
      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'CashCollectionType' | translate }}</mat-label>
          <mat-select name="CashCollectionType" [(ngModel)]="currentCashCollettion.Type" [compareWith]="compareFn">
            <mat-option *ngFor="let type of this.CashCollectTypes;" [value]="type">
              {{type.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
          <mat-select name="AccountNumber" [(ngModel)]="currentCashCollettion.BankAccount" [compareWith]="compareFn">
            <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
              {{b.DisplayValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>

    <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
      <mat-label>{{ 'CollectionDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentCashCollettion.CollectionDate">
      <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
      <mat-datepicker #dp3></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
      <mat-label>{{ 'CollectionValue' | translate }}* [{{this.currentCashCollettion.Currency.Name}}]</mat-label>
      <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Value" (change)="VerifyPriceModel(this.currentCashCollettion.Value);">
      <mat-icon matSuffix>monetization_on</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
      <mat-label>{{ 'CollectionExternalID' | translate }}</mat-label>
      <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.CollectionExternalID">
      <mat-icon matSuffix>qr_code_2</mat-icon>
    </mat-form-field>

    <p class="CashCollectRemainingInfo" *ngIf="this.CollectionRemainingValue >= 0;">{{'RemainingToCashCollect' | translate}}: {{this.CollectionRemainingValue}} {{this.currentCashCollettion.Currency.Name}}</p>
    <p class="CashCollectRemainingInfo" *ngIf="this.CollectionRemainingValue < 0;">{{'OverCashCollected' | translate}}: {{this.CollectionRemainingValue}} {{this.currentCashCollettion.Currency.Name}}</p>
   </div>

   <div class="PopUpCommands">
    <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddCashCollection();ShowCashCollectionContainer = false;">{{'Collect' | translate}}</button>
  </div>
</div>